const getOptions = (binding) => ({
  delay: binding.value?.delay ?? 75,
  customClass: binding.value?.class || 'v-reveal',
  customClassActive: binding.value?.activeClass || 'v-reveal-active',
})

export default {
  install: (Vue) => {
    const reveals = new WeakMap()

    Vue.directive('reveal', {
      beforeMount: (el, binding) => {
        const { customClass } = getOptions(binding)

        el.classList.add(customClass)
      },
      mounted: (el, binding) => {
        const { delay, customClassActive } = getOptions(binding)
        const timeouts = []

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !entry.target.classList.contains(customClassActive)) {
              const timeout = setTimeout(() => {
                entry.target.classList.add(customClassActive)
              }, delay)

              timeouts.push(timeout)
            }
          })
        })

        observer.observe(el)

        reveals.set(el, { observer, timeouts })
      },
      unmounted: (el) => {
        const reveal = reveals.get(el)

        if (!reveal) return

        reveal.observer.disconnect()
        reveal.timeouts.forEach(clearTimeout)
        reveals.delete(el)
      },
    })
  },
}
